export const logout = () => {
  const priceCodeMappings = localStorage.getItem('priceCode_mappings');
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.clear();
  if (priceCodeMappings) {
    localStorage.setItem('priceCode_mappings', priceCodeMappings);
  }
  window.location.href = "/login";
};
